import React from 'react';
import { PromptDocuments, PromptGroup } from 'types/candidateStories';
import CandidateStoryItemTitle from './CandidateStoryItemTitle';
import PromptSummaryItemsList from './PromptSummaryItemsList';
import PromptSummaryFileList from './PromptSummaryFileList';

const PromptSummaryGeneralSection = ({
  generalResponses,
  generalDocuments,
  promptGroups,
}: {
  generalResponses: Record<string, string>;
  generalDocuments: PromptDocuments;
  promptGroups: PromptGroup[];
}) => {
  const hasGeneralResponses = Object.keys(generalResponses).length > 0;
  const hasGeneralDocuments =
    generalDocuments && Object.keys(generalDocuments).length > 0;

  if (!hasGeneralResponses && !hasGeneralDocuments) {
    return null;
  }

  return (
    <div
      className='cans-item-wrapper'
      data-testid='prompt-summary-general-section'
    >
      <h5 className='mb-3'>
        <CandidateStoryItemTitle />
      </h5>
      <PromptSummaryItemsList
        promptResponses={generalResponses}
        promptGroups={promptGroups}
      />
      <PromptSummaryFileList
        documents={generalDocuments}
        promptGroups={promptGroups}
      />
    </div>
  );
};

export default PromptSummaryGeneralSection;
